import { ActivityEntityName } from '../../shared/activity.entity.name';
import { ContactEntity } from '../../contact/contact.options';
import { EntityQueue } from './entity.queue';

/**
 * Board row for the Queues settings screen. Read-only projection of a queue record with the
 * owner, audience and count hydrated server side; never persisted.
 */
export interface EntityQueueDefinition extends EntityQueue {
  target?: ActivityEntityName;
  owner?: ContactEntity;
  ownerActive?: boolean;
  audience?: string;
  count?: number;
  // The Count column's text: counts are capped server-side, so a capped value reads as a floor, not a total.
  countLabel?: string;
  // Mongoose timestamps on the queue schema; surfaced here only so the board can show it as a column.
  updatedAt?: Date;
}

export interface EntityQueueTransferOwnershipRequest {
  queueId: string;
  toUserId: string;
}

/** Entity command id the Queues board sends to the definition strategy's executeCommand. */
export const ENTITY_QUEUE_TRANSFER_OWNERSHIP_COMMAND = 'transferOwnership';
